import type { IObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments } from './ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments.interface';

export default class ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments
  implements
    IObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments {
  additionalIncomeSource: boolean;
  additionalIncomeSourceComments: string;
  reduceExpenditure: boolean;
  reduceExpenditureComments: string;
  saleOfAssets: boolean;
  saleOfAssetsComments: string;
  savingsAndSuperannuation: boolean;
  savingsAndSuperannuationComments: string;
  coApplicantsIncome: boolean;
  coApplicantsIncomeComments: string;
  other: boolean;
  otherComments: string;

  static build = (
    data: IObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments
  ) =>
    new ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments(
      data
    );

  static blank = () =>
    new ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments();

  /**
   * Constructor
   * @param {IObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments} data
   */
  constructor(
    data?: IObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments
  ) {
    this.additionalIncomeSource = data?.additionalIncomeSource === true;
    this.additionalIncomeSourceComments = data?.additionalIncomeSourceComments || '';
    this.reduceExpenditure = data?.reduceExpenditure === true;
    this.reduceExpenditureComments = data?.reduceExpenditureComments || '';
    this.saleOfAssets = data?.saleOfAssets === true;
    this.saleOfAssetsComments = data?.saleOfAssetsComments || '';
    // TODO: data?.savingsAndSuperanuation is legacy data structure
    this.savingsAndSuperannuation =
      data?.savingsAndSuperanuation === true || data?.savingsAndSuperannuation === true;
    // TODO: data?.savingsAndSuperanuationComments is legacy data structure
    this.savingsAndSuperannuationComments =
      data?.savingsAndSuperanuationComments || data?.savingsAndSuperannuationComments || '';
    this.coApplicantsIncome = data?.coApplicantsIncome === true;
    this.coApplicantsIncomeComments = data?.coApplicantsIncomeComments || '';
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
  }
}
